import { render, staticRenderFns } from "./CostBearerServiceModal.vue?vue&type=template&id=e27ef0ce&scoped=true"
import script from "./CostBearerServiceModal.vue?vue&type=script&lang=ts"
export * from "./CostBearerServiceModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27ef0ce",
  null
  
)

export default component.exports